(function ($) {
	const $tabsGroups = $(".tabs-group");

	if ($tabsGroups.length) {
		$tabsGroups.on("click", ".tab", function (event) {
			event.preventDefault();

			const $this = $(this);
			const targetId = $this.data("target");

			if (!targetId || !$("#" + targetId).length) {
				console.error("Unable to find #" + targetId + " (or empty target)");
			} else {
				// On met l'onglet en actif
				$(`.tab[data-target]`).removeClass("tab--active");
				$(`.tab[data-target="${targetId}"]`).addClass("tab--active");

				// On affiche le bon panel
				$(".tab-target").hide();
				$("#" + targetId + ".tab-target").show();
			}
		});

		// Au chargement on active le premier onglet
		$tabsGroups.find(".tab").first().trigger("click");
	}

	const $tabMobile = $(".tab--mobile");

	if ($tabMobile.length) {
		$tabMobile.on("click", function (event) {
			event.preventDefault();

			const $this = $(this);
			const targetId = $this.data("target");

			if (!targetId || !$("#" + targetId).length) {
				console.error("Unable to find #" + targetId + " (or empty target)");
			} else {
				// On met l'onglet en actif
				$(`.tab[data-target]`).removeClass("tab--active");
				$(`.tab[data-target="${targetId}"]`).addClass("tab--active");

				// On affiche le bon panel
				$(".tab-target").hide();
				$("#" + targetId + ".tab-target").show();
			}
		});

		// Au chargement on active le premier onglet
		$tabsGroups.find(".tab--mobile").first().trigger("click");
	}
})(jQuery);
